import { useEffect } from 'react';

export function useCssVariable(name: string, value: string, { removeOnUnmount = false } = {}) {
  useEffect(() => {
    document.documentElement.style.setProperty(name, value);
    return () => {
      if (removeOnUnmount) {
        document.documentElement.style.removeProperty(name);
      }
    };
  }, [name, value, removeOnUnmount]);
}
